const STORAGE_KEY = 'ecom-purchase-dedup-ids';
const MAX_ENTRIES = 50;

const parseIds = (raw: string | null): Array<string> => {
  if (!raw) {
    return [];
  }
  const parsed: unknown = JSON.parse(raw);
  if (!Array.isArray(parsed)) {
    return [];
  }
  return parsed.filter((id): id is string => typeof id === 'string');
};

export const hasSeen = (transactionId: string): boolean => {
  if (!transactionId) {
    return false;
  }
  try {
    return parseIds(localStorage.getItem(STORAGE_KEY)).includes(transactionId);
  } catch {
    return false;
  }
};

export const markSeen = (transactionId: string): void => {
  if (!transactionId) {
    return;
  }
  try {
    const ids = parseIds(localStorage.getItem(STORAGE_KEY));
    if (ids.includes(transactionId)) {
      return;
    }
    const next = [...ids, transactionId].slice(-MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    return;
  }
};
